import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-more.svg'
import _imports_1 from '@/core/assets/icons/icon-edit.svg'
import _imports_2 from '@/core/assets/icons/icon-copy.svg'
import _imports_3 from '@/core/assets/icons/icon-trash.svg'


const _withScopeId = n => (_pushScopeId("data-v-7e636edd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "more"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "edit"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Edit Profile", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "duplicate"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Duplicate Profile", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "delete"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Delete Profile", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_down = _resolveComponent("drop-down")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_drop_down, {
      shouldClose: _ctx.closeDropDown,
      direction: "left",
      verticalOffset: 10,
      horizontalOffset: -20
    }, {
      clickable: _withCtx(() => [
        _hoisted_2
      ]),
      "main-actions": _withCtx(() => [
        _createElementVNode("section", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editProfile && _ctx.editProfile(...args))),
          class: "option"
        }, _hoisted_5),
        _createElementVNode("section", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.duplicateProfile())),
          class: "option"
        }, _hoisted_8),
        _createElementVNode("section", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteProfile())),
          class: "option"
        }, _hoisted_11)
      ]),
      _: 1
    }, 8, ["shouldClose"])
  ]))
}